// extracted by mini-css-extract-plugin
export default {"buttonContainer":"jpFb0","alignToEdge":"GdBDA","buttonIcon":"YFUDE","buttonCaption":"q7ced","buttonSpacer":"flZ4u"};